<template>
    <div class="available__roles__container" :class="(this.available_roles && this.available_roles.length > 0) ? 'with-margin' : '' ">

        <template v-if="this.available_roles">

            <template v-if="this.available_roles.length > 0">
                <h3>LIST OF AVAILABLE ROLES</h3>

                <div class="positions">

                    <a class="position" v-for="role, index in available_roles" :href="'/careers/' + role.slug" :key="index">
                        <p>{{ role.name }}</p>
                        <div class="span_bg"></div>
                    </a>

                </div>
            </template>
            
        </template>

    </div>
</template>
<script>
export default {
    data(){
        return {
            available_roles: null,
        }
    },
    created(){
        axios.get('/openpositions').then((response) => {
           this.available_roles = response.data;
        })
    }
}
</script>
<style lang="scss" scoped>

    .available__roles__container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        max-width: 1115px;

        &.with-margin{
            margin: 200px auto;
        }

        h3{
            color: #FFF;
            font-size: 30px;
            font-family: 'DIN Next LT Pro Bold';
            font-weight: 700;
            text-align: center;
            width: 100%;

            margin: 0;
            margin-bottom: 82px;
        }

        .positions{
            display: flex;
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;

            .position{
                display: block;
                background: rgba(15, 15, 15, 0.3);
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                width: 100%;
                max-width: 300px;
                height: 60px;
                margin: 31px 13px;
                // margin-bottom: -9px;
                cursor: pointer;
                user-select: none;
                position: relative;
                overflow-y: hidden;
                z-index: 4;
                text-decoration: none;
                border: 1px solid #ED1163;

                p{
                    color: #FFF;
                    text-align: center;
                    font-size: 16px;
                    font-family: 'DIN Next LT Pro Bold';
                    // font-weight: 700;
                    letter-spacing: 3.2px;
                    text-transform: uppercase;
                    margin: 0;
                    line-height: 60px;

                    position: relative;
                    z-index: 4;
                }

                div.span_bg{
                    background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                    height: 100%;
                    width: 100%;
                    transition: all .3s ease-in-out;
                    margin-top: auto;
                    margin-bottom: 0;
                    opacity: 0;

                    position: absolute;
                    bottom: -50px;
                    z-index: 3;
                }

                &:hover{
                    div.span_bg{
                        height: calc(100%);
                        bottom: 0;
                        opacity: 1;
                    }
                }

            }
        }
    }

</style>